import { createContext } from 'react'
import type { RecordType } from '../Components/VoiceRecording/types'

export enum ReportInputType {
  Text = 'Text',
  Voice = 'Voice',
}

type State = {
  victimPin: string | null
  setVictimPin: (pin: string | null) => void
  createdAt: Date | null
  setCreatedAt: (date: Date) => void
  recording: RecordType | null
  setRecording: (recording: RecordType | null) => void
  buildRecordingFile: () => Promise<File | null>
  tag: string | null
  setTag: (id: string) => void
  isAnonymous: boolean
  setIsAnonymous: (isReportAnonymous: boolean) => void
  reportInputType: ReportInputType
  setReportInputType: (type: ReportInputType) => void
}

export const ReportFormContext = createContext<State>({
  victimPin: null,
  setVictimPin: () => undefined,
  createdAt: null,
  setCreatedAt: () => undefined,
  recording: null,
  setRecording: () => undefined,
  buildRecordingFile: () => Promise.resolve(null),
  isAnonymous: true,
  setIsAnonymous: () => undefined,
  tag: null,
  setTag: () => undefined,
  reportInputType: ReportInputType.Text,
  setReportInputType: () => undefined,
})
